module.exports = __webpack_public_path__ + "static/media/e9e81b34-ebdf-4d19-9576-d284f3674bec.a34c7ffc.JPG";